import globals from '../../styles/globals';
import { dimensions } from '../../styles/globals';

export default (theme) => ({
    ...globals(theme),
    masterPage: {
        padding: 15,
        backgroundColor: theme.palette.background.default,
        transition: theme.transitions.create(['margin', 'width'], {
            duration: theme.transitions.duration.leavingScreen,
            easing: theme.transitions.easing.sharp
        })
    },
    loggedInPage: {
        marginLeft: 0
    }    
});

export const divShadow={
    boxShadow: '0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12)',
    marginBottom : '3px',
    maxwidth: '100%',
    height: globals.TOP_BAR_HEIGHT,
    background: 'linear-gradient(0deg, rgba(250,250,250,1) 0%, rgba(255,255,255,1) 100%)',
    marginLeft: '0px',
    marginBottom: '10px'
}

